import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { Table, Icon, Heading, toast } from '@lionstep/ui';

// Queries
import { useUserCollaborators } from '../../../../../../../queries/userQueries';
import {
  useDeleteUserFromJobMutation,
  useDeleteJobMailingPermissionsMutation,
} from '../../../../../../../queries/jobQueries';

// Styles
import styles from './collaboratorsTable.module.scss';

const CollaboratorsTable = ({ collaboratorsOnJob, job }) => {
  const { t } = useTranslation();
  const { refetch: getUserCollaborators } = useUserCollaborators({
    options: { enabled: false },
  });

  const { mutateAsync: deleteUserFromJob } = useDeleteUserFromJobMutation({
    onSuccess: () => {},
    onError: (error) => {
      toast.error('Error removing collaborator from the job', {
        id: 'REMOVE_JOB_COLLABORATOR_FAIL',
        statusCode: error?.response?.status,
      });
    },
  });

  const { mutateAsync: deleteJobMailingPermissions } =
    useDeleteJobMailingPermissionsMutation({
      onSuccess: () => {},
      onError: (error) => {
        toast.error('Error adding mailing permission to a collaborator', {
          id: 'REMOVE_COLLABORATOR_MAILING_PERMISSION_FAIL',
          statusCode: error?.response?.status,
        });
      },
    });

  const handleOnRemoveCollaborator = async (userId) => {
    await deleteUserFromJob({ jobId: job.id, userId });
    await deleteJobMailingPermissions({
      jobId: job.id,
      data: { user_id: userId },
    });
    getUserCollaborators();
  };

  return (
    <>
      <Heading className={styles.collaboratorTitle} level={4}>
        {t('collaborators_on_job')}
      </Heading>
      <Table>
        <Table.Header>
          <Table.HeaderRow>
            <Table.HeaderCell>{t('name')}</Table.HeaderCell>
            <Table.HeaderCell>{t('email')}</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">{t('role')}</Table.HeaderCell>
          </Table.HeaderRow>
        </Table.Header>
        <Table.Body>
          {collaboratorsOnJob.map((collaborator) => (
            <Table.Row key={collaborator.local_id}>
              <Table.Cell>{collaborator.display_name}</Table.Cell>
              <Table.Cell>{collaborator.email}</Table.Cell>
              <Table.Cell
                textAlign="center"
                className={styles.collaboratorRoleCell}
              >
                {collaborator.role}
                <span
                  className={styles.collaboratorRemoveIcon}
                  onClick={() =>
                    handleOnRemoveCollaborator(collaborator.local_id)
                  }
                >
                  <Icon name="CloseCircle" />
                </span>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  );
};

CollaboratorsTable.defaultProps = {
  job: {},
};

CollaboratorsTable.propTypes = {
  collaboratorsOnJob: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  job: PropTypes.shape(),
};

export default CollaboratorsTable;
